module.exports = __webpack_public_path__ + "static/media/techview-green.acc5077d.svg";